<template>
  <aside class="gc-sidebar">
    <nav class="gc-sidebar__nav" aria-label="Navigation génération de contenus">
      <SharedNavigationListItem
        v-for="item in mainItems"
        :key="item.key"
        :label="item.label"
        with-icon
        full-width
        :selected="isSelected(item.to)"
        @click="navigate(item.to)"
      >
        <template #icon>
          <span class="gc-sidebar__icon" v-html="item.icon" />
        </template>
      </SharedNavigationListItem>
    </nav>

    <div v-if="showSettings" class="gc-sidebar__footer">
      <SharedNavigationListItem
        :label="settingsItem.label"
        with-icon
        full-width
        :selected="isSelected(settingsItem.to)"
        @click="navigate(settingsItem.to)"
      >
        <template #icon>
          <span class="gc-sidebar__icon" v-html="settingsItem.icon" />
        </template>
      </SharedNavigationListItem>
    </div>
  </aside>
</template>

<script setup>
import homeIcon from "~/assets/svg/home_fill.svg?raw";
import assignmentIcon from "~/assets/svg/assignment.svg?raw";
import avgPaceIcon from "~/assets/svg/avg_pace.svg?raw";
import historyIcon from "~/assets/svg/history.svg?raw";
import archiveIcon from "~/assets/svg/archive.svg?raw";
import folderIcon from "~/assets/svg/folder.svg?raw";
import settingsIcon from "~/assets/svg/settings.svg?raw";

const route = useRoute();
const router = useRouter();

const defaultItems = [
  {
    key: "dashboard",
    label: "Tableau de bord",
    to: "/generation-contenus",
    icon: homeIcon,
  },
  {
    key: "creation",
    label: "Création de contenu",
    to: "/generation-contenus/creation",
    icon: assignmentIcon,
  },
  {
    key: "en-cours",
    label: "En cours",
    to: "/generation-contenus/en-cours",
    icon: avgPaceIcon,
  },
  {
    key: "historique",
    label: "Historique",
    to: "/generation-contenus/historique",
    icon: historyIcon,
  },
  {
    key: "archives",
    label: "Archives",
    to: "/generation-contenus/archives",
    icon: archiveIcon,
  },
  {
    key: "base-ostie",
    label: "Base OSTIE",
    to: "/generation-contenus/base-ostie",
    icon: folderIcon,
  },
];

const validateurItems = [
  {
    key: "validateur-dashboard",
    label: "Tableau de bord",
    to: "/generation-contenus/validateur/dashboard",
    icon: homeIcon,
  },
  {
    key: "validateur-historique",
    label: "Historique",
    to: "/generation-contenus/validateur/historique",
    icon: historyIcon,
  },
  {
    key: "validateur-archives",
    label: "Archives",
    to: "/generation-contenus/validateur/archive",
    icon: archiveIcon,
  },
];

const redacteurItems = [
  {
    key: "redacteur-dashboard",
    label: "Tableau de bord",
    to: "/generation-contenus/redacteur/dashboard",
    icon: homeIcon,
  },
  {
    key: "redacteur-creation",
    label: "Création de contenu",
    to: "/generation-contenus/redacteur/creation-contenue",
    icon: assignmentIcon,
  },
  {
    key: "redacteur-en-cours",
    label: "En cours",
    to: "/generation-contenus/redacteur/en-cours",
    icon: avgPaceIcon,
  },
  {
    key: "redacteur-historique",
    label: "Historique",
    to: "/generation-contenus/redacteur/historique",
    icon: historyIcon,
  },
  {
    key: "redacteur-archives",
    label: "Archives",
    to: "/generation-contenus/redacteur/archives",
    icon: archiveIcon,
  },
  {
    key: "redacteur-base-ostie",
    label: "Base OSTIE",
    to: "/generation-contenus/redacteur/base-ostie",
    icon: folderIcon,
  },
];

const isValidateurContext = computed(() =>
  route.path.startsWith("/generation-contenus/validateur")
);

const isRedacteurContext = computed(() =>
  route.path.startsWith("/generation-contenus/redacteur")
);

const mainItems = computed(() => {
  if (isValidateurContext.value) return validateurItems;
  if (isRedacteurContext.value) return redacteurItems;
  return defaultItems;
});

const showSettings = computed(
  () => !isValidateurContext.value
);

const settingsItem = computed(() => ({
  key: "parametres",
  label: "Paramètres",
  to: isRedacteurContext.value
    ? "/generation-contenus/redacteur/parametres"
    : "/generation-contenus/parametres",
  icon: settingsIcon,
}));

function isSelected(to) {
  if (to === "/generation-contenus") {
    return route.path === "/generation-contenus";
  }
  return route.path === to || route.path.startsWith(`${to}/`);
}

function navigate(to) {
  if (route.path !== to) {
    router.push(to);
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.gc-sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;
  align-self: stretch;
  box-sizing: border-box;
  width: 200px;
  max-width: 220px;
  height: 100%;
  min-height: 0;
  padding: 12px;
  gap: 8px;
  background-color: $white;
  border: none;
  overflow: hidden;
  position: relative;

  &__nav,
  &__footer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  &__icon {
    display: inline-flex;
    width: 18px;
    height: 18px;
    color: inherit;

    :deep(svg) {
      width: 18px;
      height: 18px;
      display: block;
    }
  }
}
</style>
